var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChats = function SvgChats(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chats"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.125 3.75H8.625V2.25C8.625 2.05109 8.54598 1.86032 8.40533 1.71967C8.26468 1.57902 8.07391 1.5 7.875 1.5H1.875C1.67609 1.5 1.48532 1.57902 1.34467 1.71967C1.20402 1.86032 1.125 2.05109 1.125 2.25V8.25C1.12522 8.32055 1.14534 8.38961 1.18304 8.44924C1.22075 8.50887 1.27451 8.55665 1.33815 8.5871C1.40179 8.61755 1.47273 8.62943 1.54282 8.62138C1.61291 8.61332 1.6793 8.58566 1.73438 8.54156L3.375 7.21875V8.625C3.375 8.82391 3.45402 9.01468 3.59467 9.15533C3.73532 9.29598 3.92609 9.375 4.125 9.375H8.51203L10.2656 10.7916C10.332 10.8452 10.4147 10.8747 10.5 10.875C10.5995 10.875 10.6948 10.8355 10.7652 10.7652C10.8355 10.6948 10.875 10.5995 10.875 10.5V4.5C10.875 4.30109 10.796 4.11032 10.6553 3.96967C10.5147 3.82902 10.3239 3.75 10.125 3.75ZM3.11953 6.45844L1.875 7.46484V2.25H7.875V6.375H3.35531C3.26949 6.37501 3.18626 6.40446 3.11953 6.45844ZM10.125 9.71484L8.88047 8.70844C8.81411 8.65477 8.73144 8.62533 8.64609 8.625H4.125V7.125H7.875C8.07391 7.125 8.26468 7.04598 8.40533 6.90533C8.54598 6.76468 8.625 6.57391 8.625 6.375V4.5H10.125V9.71484Z",
    fill: "#5F5F75"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChats, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Chats.f11e01c8.svg";
export { ForwardRef as ReactComponent };